










import { Component, Vue } from 'vue-property-decorator';
import DirectoryListNavigationDrawer from '@/components/storage/drawers/directoryListNavigationDrawer/DirectoryListNavigationDrawer.vue';
import UseFileListBase from '@/components/storage/storageList/useFileList/UseFileListBase.vue';
import DirectoryContentsBase from '@/components/storage/storageList/directoryContents/DirectoryContentsBase.vue';
import { vxm } from '@/store';
import { FindDirectoriesAndFilesQueryDto } from '@/@types/Directory';

@Component({
  components: {
    DirectoryListNavigationDrawer,
    UseFileListBase,
    DirectoryContentsBase,
  },
})
export default class StorageBase extends Vue {
  private components: Array<typeof UseFileListBase | typeof DirectoryContentsBase> = [
    UseFileListBase,
    DirectoryContentsBase,
  ];
  private componentIndex: { outside: number; inside: number } = { outside: 0, inside: 1 };

  private async created() {
    const query: FindDirectoriesAndFilesQueryDto = {
      'project-id': this.projectId,
      'order': 'asc',
    };
    await Promise.all([
      vxm.theoryApi.directoriesStore.fetchDirectoriesAndFiles(query),
      vxm.theoryApi.directoriesStore.fetchCurrentDirectoryAndFiles(query),
    ]);
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId ?? 0;
  }

  private get storageBaseViewComponent(): typeof UseFileListBase | typeof DirectoryContentsBase {
    return this.components[this.componentIndex.inside];
    //TODO: outsideの場合useFileListBaseコンポーネントが表示されるが、使う場面が分からないためコメントアウト(井上)
    // if (!this.isView) {
    //   return this.components[this.componentIndex.outside];
    // } else {
    //   return this.components[this.componentIndex.inside];
    // }
  }
}
